/* Model */
class TimeWindowTypeModel extends App.Models.BaseModel {
    modelUrl = 'TimeWindowType';
}

App.Models.TimeWindowType = TimeWindowTypeModel;

/* Collection */
class TimeWindowTypeCollection extends App.Collections.BaseCollection {
    url = 'TimeWindowType';
    model = App.Models.TimeWindowType;
}

App.Collections.TimeWindowTypes = TimeWindowTypeCollection;

/* Router */
class TimeWindowTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'TimeWindowType';
        const model = App.Models.TimeWindowType;
        const collectionClass = App.Collections.TimeWindowTypes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.TimeWindowType = TimeWindowTypeRouter;
